import React, { FC } from 'react';
import clsx from 'clsx';
import { Box, Typography } from '@material-ui/core';
import percentageWithLabelStyles from './valueWithLabelStyles';
import ElementLoaderWrapper from '../../informativeSection/elementLoaderWrapper/ElementLoaderWrapper';

export interface IValueWithLabelProps {
  value: string | number | JSX.Element;
  label?: string | JSX.Element;
  classes?: {
    container?: string;
    value?: string;
    label?: string;
  };
}

const ValueWithLabel: FC<IValueWithLabelProps> = ({ value, label, classes, ...props }) => {
  const styles = percentageWithLabelStyles();

  return (
    <Box
      justifyContent={'center'}
      alignItems={'center'}
      flexDirection={'column'}
      className={clsx([styles.container, classes?.container])}
      {...props}
    >
      <Box>
        <ElementLoaderWrapper>
          <Typography
            component="p"
            variant={'subtitle1'}
            className={clsx([styles.value, classes?.value])}
            data-test="value_with_label:value"
          >
            {value}
          </Typography>
        </ElementLoaderWrapper>
      </Box>
      {label && (
        <Box>
          <Typography
            component="p"
            variant={'helpingText'}
            className={clsx([styles.label, classes?.label])}
            data-test="value_with_label:label"
          >
            {label}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default ValueWithLabel;
